module.exports = __webpack_public_path__ + "static/media/backgroundLandscape.89aedde1.svg";